import React from "react";
import { EventEmitter } from "../event";
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LogoutIcon from '@mui/icons-material/Logout';
import { Outlet, Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';
import PendingIcon from '@mui/icons-material/Pending';
import { SwipeableDrawer } from "@mui/material";
import { clearLocalStrorage, setLocalstorage } from "./common/codeHelper";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';


const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));


const appBarSpina = {
  title: {
    cursor: 'pointer'
  },
  color: {
    color: 'red'
  },
  background: {
    background: '#2b8f35 ' //'#00a5c1'
  }
};


const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));
const DrawerFooter = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
  bottom: '10px',
  position: 'absolute',
  fontSize: '12px'
}));

export default function PersistentDrawerLeft() {
  // let [isLogin, setIslogin] = useState(localStorage.getItem("isLogin"));
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  let info = JSON.parse(localStorage.getItem("userProfileInfo"));
  // let loggedUserinfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
  EventEmitter.subscribe("loginChanged", (event) => {
    info = JSON.parse(localStorage.getItem("userProfileInfo"));
  })

  const logout = () => {
    EventEmitter.dispatch("loginChanged", "false");
    clearLocalStrorage();
    navigate('Login', { replace: true });
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setOpen(open);
  };
  const showOnBoarding = () =>{
    setLocalstorage('onborading', null);
    EventEmitter.dispatch("onBoardingChange", "false");
  }

  return (
    <Box sx={{ display: 'flex', }}>
      <AppBar position="fixed" open={open} >
        <Toolbar style={appBarSpina.background} className="hero-welcome animate__animated animate__fadeInDown  ">
          <IconButton
            color="inherit"
            className="animate__animated animate__fadeInRight"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: 'none' }) }}
          >
            <MenuIcon />
          </IconButton>
          <div className="text-white grid grid-cols-2 w-full">
            <div className="animate__animated animate__rotateInDownLeft self-center text-xl font-medium ">Virtue Report Interface</div>
            <div className="w-96 justify-self-end text-right font-no ">
              {info && <div className="capitalize text-sm mt-1">
                <span className="pr-2 "> {info.mappedTo.name}</span>
                <span className="text-blue-600 -mt-1">|</span>
                {/* <span className="pl-2 mr-2">{loggedUserinfo.orgRef.name}</span> */}
                <span className="border shadow border-blue-700   px-3 py-1 ml-2">Surgeon View</span>
                <span className="ml-2" onClick={showOnBoarding}><ReportGmailerrorredIcon></ReportGmailerrorredIcon></span>
              </div>}

            </div>
          </div>
        </Toolbar>
      </AppBar>
      <SwipeableDrawer className="animate__animated animate__fadeInLeft"
        sx={{
          width: drawerWidth,
          backgroundColor: '#2b8f35',
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        PaperProps={{
          sx: {
            backgroundColor: '#2b8f35',
            color: "#fff",
          }
        }}
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      // onClose={onChangeDrawer}
      // onOpen={onChangeDrawer}
      >
        <DrawerHeader >
          <div onClick={handleDrawerClose}>Back</div>
          <IconButton onClick={handleDrawerClose} sx={{ color: "#fff" }}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {['Home', 'AccessLog', 'waitingList'].map((text, index) => (
            <Link to={text} key={index}>
              <ListItem button key={index} onClick={handleDrawerClose}>
                <ListItemIcon >
                  {/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
                  {index === 0 ? <HomeIcon sx={{ color: "#fff" }} /> : ''}
                  {index === 1 ? <GridViewIcon sx={{ color: "#fff" }} /> : ''}
                  {index === 2 ? <ViewListIcon sx={{ color: "#fff" }} /> : ''}
                  {index === 3 ? <PendingIcon sx={{ color: "#fff" }} /> : ''}
                </ListItemIcon>
                {index === 0 && text}
                {index === 1 && 'Access Log'}
                {index === 2 && 'Waiting List'}
              </ListItem>
            </Link>
          ))}
        </List>
        <Divider />
        <List>
          {['Logout'].map((text, index) => (
            <ListItem button key={index} onClick={handleDrawerClose}>
              <ListItemIcon sx={{ color: "#fff" }}>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText onClick={logout} primary={text} />
            </ListItem>
          ))}
        </List>
        <Divider />
        <DrawerFooter>
          <div >
            Copyright © 2022 Virtue Analytics Inc.
            All Rights Reserved.
          </div>
        </DrawerFooter>
      </SwipeableDrawer>
      <Main open={open} className={'margin-top: 60px;'}>
        <DrawerHeader />
        <Outlet />
      </Main>
    </Box>
  );
}
